import request from '@/utils/request'
import qs from 'qs'

// 查询证书列表
export const queryCertificate = params => {
  return request({
    url: '/api/certificate',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})  //处理对象中包含数组的格式
    }
  })
}
export const outPutCertificate = (params) => {
  return request({
    url: '/api/certificate/export',
    method: 'GET',
    responseType: 'arraybuffer',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}
// 查询单个证书
export const getCertificate = id => {
  return request({
    url: '/api/certificate/'+id,
    method: 'GET'
  })
}
// 查询关键件证书详情
export const getKeyCertificate = id => {
  return request({
    url: '/api/keyPieceCertificate/'+id,
    method: 'GET'
  })
}
// 添加证书
export const addCertificate = params => {
  return request({
    url: '/api/certificate',
    method: 'POST',
    data: params
  })
}

// 添加证书
export const putCertificate = params => {
  return request({
    url: '/api/certificate',
    method: 'PUT',
    data: params
  })
}

// 添加证书选择企业列表
export const selectCompany = params => {
  return request({
    url: '/api/company',
    method: 'GET'
  })
}
// 删除证书
export const deteleCertificateList = id => {
  return request({
    url: '/api/certificate/'+id,
    method: 'delete'
  })
}
// 批量删除证书
export const deleteCertificateListBatch = id => {
  return request({
    url: '/api/certificate/batch/'+id,
    method: 'delete'
  })
}

// 新增证书附件
export const addCertificateFile = params => {
  return request({
    url: '/api/certificateFile',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 删除证书附件
export const deleteCertificateFile = params => {
  return request({
    url: '/api/delCertificateFile',
    method: 'POST',
    data: qs.stringify(params)
  })
}

//证书类别下拉框
export const categoryForCert = () => {
  return request({
    url: '/api/categoryForCert',
    method: 'GET'
  })
}

//  修改证书标签
export const certificateLable = params => {
  return request({
    url: '/api/certificateLable',
    method: 'PUT',
    data: params
  })
}

// 证书变更
export const changeCertificate = params => {
  return request({
    url: '/api/certificateChange',
    method: 'PUT',
    data: params
  })
}

// 证书维护
export const keyPieceCertificate = params => {
  return request({
    url: '/api/keyPieceCertificate',
    method: 'POST',
    // data: params
    data:params
  })
}

// 变更记录提升

export const changeUpAction = (id) => {
  return request({
    url: '/api/reportUp',
    method: 'PUT',
    data: {
      'id': id
    }
  })
}
// 变更记录下降
export const changeDownAction = (id) => {
  return request({
    url: '/api/reportDown',
    method: 'PUT',
    data: {
      'id': id
    }
  })
}

//根据编号判断证书是否存在
export const checkCertificate = (deptId, number) => {
  return request({
    url: '/api/certificate/check?deptId=' + deptId + '&number=' + number,
    method: 'GET'
  })
}

// 随整机测试关键件维护列表数据
export const getDefendInfo = (id) => {
  return request({
    url: '/api/keyPieceTest/search/' + id,
    method: 'GET'
  })
}

//更新随整机测试关键件
export const changeTestKey = (params) => {
  return request({
    url: '/api/certificate/keyPieceTest',
    method: 'PUT',
    data: params 
  })
}

// 获取照片列表
export const getPhotoList = (id) => {
  return request({
    url: '/api/certificate/photo?id=' + id,
    method: 'GET'
  })
}
// 获取铭牌照片
export const getShowPhotoList = (id) => {
  return request({
    url: '/api/certificate/nameplatePhoto?id=' + id,
    method: 'GET'
  })
}
// 重命名文件名
export const renameFileName = (params) => {
  return request({
    url: '/api/alioss/rename',
    method: 'PUT',
    data: params 
  })
}
// 删除图片
export const deletePhoto = (id, photoId) => {
  return request({
    url: '/api/certificate/photo?id=' + id + '&photoId=' + photoId,
    method: 'DELETE'
  })
}
// 上传图片
export const addPhoto = (id, photoId) => {
  return request({
    url: '/api/certificate/photo?id=' + id + '&photoId=' + photoId,
    method: 'POST'
  })
}

export const addPhotos = (params) => {
  return request({
    url: '/api/certificate/photo/bulk',
    method: 'POST',
    data: params
  })
}

export const uploadPhotos = (params) => {
  return request({
    url: '/api/ossPrivateConfig/bulk',
    method: 'POST',
    data: params
  })
}

// 修改图片
export const editPhoto = (id, newPhotoId, oldPhotoId) => {
  return request({
    url: '/api/certificate/photo?id=' + id + '&newPhotoId=' + newPhotoId + '&oldPhotoId=' + oldPhotoId,
    method: 'PUT'
  })
}

// 上传铭牌图片
export const addHeaderPhoto = (id, photoId) => {
  return request({
    url: '/api/certificate/nameplatePhoto?id=' + id + '&photoId=' + photoId,
    method: 'POST'
  })
}
// 删除铭牌图片
export const deleteHeaderPhoto = (id, photoId) => {
  return request({
    url: '/api/certificate/nameplatePhoto?id=' + id + '&photoId=' + photoId,
    method: 'DELETE'
  })
}
// 修改铭牌图片
export const editHeaderPhoto = (id, newPhotoId, oldPhotoId) => {
  return request({
    url: '/api/certificate/nameplatePhoto?id=' + id + '&newPhotoId=' + newPhotoId + '&oldPhotoId=' + oldPhotoId,
    method: 'PUT'
  })
}
// 拖拽排序
export const sortPhoto = (params) => {
  return request({
    url: '/api/alioss/sort',
    method: 'PUT',
    data: params
  })
}

//产品类别
export const productSort = () => {
  return request({
    url: '/api/certificate/productcatagory',
    method: 'GET',
  })
}
//成品型号绑定查询
export const bindkeyPieceModel = (certificateId, keyPieceCertificateId) => {
  return request({
    url: '/api/certificate/keyPieceModel?certificateId=' + certificateId + '&keyPieceCertificateId=' + keyPieceCertificateId,
    method: 'GET',
  })
}
//成品型号更新查询
export const updatekeyPieceModel = (params) => {
  return request({
    url: '/api/certificate/keyPieceModel',
    method: 'PUT',
    data: params
  })
}

// 
//导出证书模板
export const exportTemplate  = () => {
  return request({
    url: '/api/certificate/excelTemplate',
    method: 'GET',
    responseType: 'blob'
  })
}

//  批量导入证书接口（会返回一个文件流）
export const importExcel  = (data) => {
  return request({
    url: '/api/certificate/importExcel',
    method: 'POST',
    responseType: 'blob',
    data: data
  })
}